import { delphoiData } from 'types/send';
import { isAndroid } from 'utils/platform';
import { getDeviceModal } from 'utils/getDeviceModal';
import { applicationService } from 'services/application';
import { resolveFromToken } from 'utils/resolveFromToken';
import { DelphoiEventData } from 'types/event';

export function createDelphoiData({
  event = 'pageview',
  action = 'pageview',
  ...restData
}: DelphoiEventData): delphoiData<Record<string, string>> {
  return {
    event,
    channel: getChannel(),
    pid: applicationService.getPid() as string,
    sid: applicationService.getSid() as string,
    tv003: action,
    tv006: applicationService.getAbTestingValues() as string,
    tv007: resolveFromToken('userId') as string,
    tv011: applicationService.getUniqueId() as string,
    tv012: isAndroid() ? 'Android' : 'Iphone',
    tv015: `${window.screen.width}*${window.screen.height}`,
    tv016: applicationService.getAppVersion() ?? 'unknown',
    tv017: isAndroid() ? getDeviceModal() : 'iPhone',
    tv020: 'digital_services',
    tv037: Date.now().toString(),
    ...restData,
  };
}

function getChannel(): string {
  const userAgent = navigator.userAgent || navigator.vendor;

  if (/android/i.test(userAgent)) {
    return 'android';
  }

  if (/iPad/i.test(userAgent)) {
    return 'ipad';
  }

  if (/iPhone/i.test(userAgent)) {
    return 'iphone';
  }

  if (/iPod/i.test(userAgent)) {
    return 'ipod';
  }

  return 'unknown';
}
